<template>
  <div class="directTree" ref="chartdiv"></div>
</template>

<script>
import _ from "lodash";
import { mapState, mapGetters } from "vuex";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4plugins_forceDirected from "@amcharts/amcharts4/plugins/forceDirected";
import { REFINERY_COLORS } from "@/constant/colors";
import { DIRECT_TREE_TYPE, REFINERY_ID } from "@/constant";
import moment from "moment";

export default {
  name: "directTree",
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      defaultData: {
        name: "ยอดรวมน้ำมัน",
        value: 0,
        type: "oil",
        colors: REFINERY_COLORS.ALL,
      },
      dafaultRefienyData: {},
      treeData: null,
      refMMSI: null,
      config: {
        startDate: this.startDate,
        endDate: this.endDate,
        forwardTankerId: "",
        tankerId: "",
        vesselId: "",
      },
    };
  },
  mounted() {
    this.$store.dispatch("getMpTankerAll");
  },
  computed: {
    ...mapState({
      refineryName: (state) => state.vesselTrip.currentRefineryName,
      currentRefID: (state) => state.vesselTrip.currentRefineryID,
      data: (state) => state.vesselTrip.data,
      tankers: (state) => state.mpTankerData.mpTankerAll,
      transferLogsByConfig: (state) => state.mpVesselData.transferLogsByConfig,
    }),
    ...mapGetters({
      getterAllDirectData: "getterAllDirectData",
      getMpTankerName: "getMpTankerName",
      getMpVesselName: "getMpVesselName",
      getTankerbyMMSI: "getTankerbyMMSI",
      getTransferLogs: "getTransferLogs",
    }),
  },
  watch: {
    async refineryName(val) {
      if (val == "ALL") {
        await this.setAllData();
      } else await this.setRefineryData(REFINERY_ID[val]);
    },
    data(val, oldval) {
      if (!_.isEqual(val, oldval)) {
        if (this.refineryName == "ALL") {
          this.setAllData();
        } else this.setRefineryData(REFINERY_ID[this.refineryName]);
      }
    },
    startDate(val, oldval) {
      if (!_.isEqual(val, oldval)) {
        this.config.startDate = this.startDate;
        this.config.endDate = this.endDate;
      }
    },
    endDate(val, oldval) {
      if (!_.isEqual(val, oldval)) {
        this.config.startDate = this.startDate;
        this.config.endDate = this.endDate;
      }
    },
  },
  methods: {
    init(networkData, flag = false) {
      const chartdiv = this.$refs.chartdiv;
      const chart = am4core.create(
        chartdiv,
        am4plugins_forceDirected.ForceDirectedTree
      );
      chart.width = am4core.percent(100);
      chart.height = am4core.percent(100);
      chart.legend = new am4charts.Legend();
      chart.legend.maxHeight = 50;
      // chart.legend.scrollable = true;
      // chart.preloader.disabled = true;
      const networkSeries = chart.series.push(
        new am4plugins_forceDirected.ForceDirectedSeries()
      );

      networkSeries.nodes.template.expandAll = flag;

      // set default data when networkData is null or undefined
      networkSeries.data = networkData || [];

      networkSeries.dataFields.linkWith = "linkWith";
      networkSeries.dataFields.name = "name";
      networkSeries.dataFields.id = "id";
      networkSeries.dataFields.value = "value";
      networkSeries.dataFields.children = "children";
      networkSeries.dataFields.isVessel = "isVessel";
      networkSeries.dataFields.type = "type";
      networkSeries.nodes.template.tooltipText = "{name} : {value} ล.";
      networkSeries.nodes.template.fillOpacity = 1;

      networkSeries.nodes.template.label.text = "{name}";
      networkSeries.fontSize = 16;
      // if (!flag) {
      //   networkSeries.maxLevels = 3;
      // }
      networkSeries.maxLevels = 3;
      networkSeries.maxRadius = 50;
      networkSeries.minRadius = 30;
      networkSeries.manyBodyStrength = -25;
      networkSeries.nodes.template.label.hideOversized = true;
      networkSeries.nodes.template.label.truncate = true;
      networkSeries.links.distance = 2;
      networkSeries.dataFields.color = "colors";
      const vm = this;
      networkSeries.nodes.template.events.on("hit", function(ev) {
        const currentItem = ev.target.dataItem;
        const name = currentItem.name;
        const id = currentItem.id;
        const type = currentItem.type;
        const dataContext = currentItem.dataContext;
        const mmsi = _.get(dataContext, "vessel.mmsi");
        const transfer_date = _.get(dataContext, "transfer_date");

        switch (type) {
          case DIRECT_TREE_TYPE.REFINERY:
            vm.onClickRefinery(vm, id, name);
            break;
          case DIRECT_TREE_TYPE.OIL:
            vm.onClickOil(vm, type);
            break;
          case DIRECT_TREE_TYPE.TANKER:
            vm.onClickTanker(vm, name, mmsi);
            break;
          case DIRECT_TREE_TYPE.VESSEL:
            vm.onClickVessel(vm, dataContext.id, name, transfer_date);
            break;
          default:
            break;
        }
      });
      chart.preloader.disabled = true;
    },
    changeRefname(event) {
      this.$store.dispatch("fetchRefName", event);
    },
    changeRadarName(event) {
      this.$store.dispatch("setRadarName", event);
    },
    changeData(val) {
      this.$store.dispatch("setRefineryData", val);
    },
    changeRefID(id) {
      this.$store.dispatch("setCurrentRefID", id);
    },
    onClickRefinery(vm, id, name) {
      vm.changeRefID(id);
      vm.changeRefname(name);
      vm.changeRadarName(name);
      vm.$store.dispatch("setType", "tanker");
      vm.$store.dispatch("setTankerName", name);
    },
    onClickOil(vm, type) {
      // vm.changeRefname(DIRECT_TREE_TYPE.OIL);
      vm.$store.dispatch("setType", type);
      vm.changeRadarName("ALL");
      // vm.$store.dispatch("setRadar", "ALL");
    },
    async onClickTanker(vm, name, mmsi) {
      vm.$store.dispatch("panTo", mmsi);
      vm.$store.dispatch("setType", "vessel");
      vm.$store.dispatch("setTankerName", name);
      const tankerByMMSI = vm.getTankerbyMMSI(mmsi);
      if (_.isUndefined(tankerByMMSI)) {
        this.$fire({
          type: "error",
          title: "mmsi ไม่ถูกต้อง",
          text: mmsi + " ไม่ถูกต้อง!",
        });
      } else {
        vm.config.forwardTankerId = tankerByMMSI.id;
        vm.config.tankerId = "";
        await vm.$store.dispatch("getMpTranferLogs", vm.config);
        // console.log("tanker: ",mmsi,name,vm.config);
      }
    },
    async onClickVessel(vm, id, name, transfer_date) {
      vm.config.forwardTankerId = "";
      vm.config.tankerId = id;
      await vm.$store.dispatch("getMpTranferLogsByVessel", vm.config);

      const tanker = _.find(vm.tankers, { id });
      vm.$store.dispatch("panTo", tanker.mmsi);
      vm.$store.dispatch("setType", "transfer");
      vm.$store.dispatch("setTankerName", name);
      // console.log("vessel: ",id,tanker.mmsi,name,vm.config);
    },
    setAllData() {
      let tree = this.$store.getters.getterNewData;
      const network = [
        {
          ...this.defaultData,
          value: _.reduce(tree, (sum, a) => (sum += a.value), 0),
          children: [...tree],
        },
      ];
      let networkData = this.data.length ? network : [this.defaultData];
      this.treeData = networkData;

      this.init(networkData);
    },
    setRefineryData(refineryID) {
      let arr = _.filter(this.data, { station_id: refineryID });
      if (arr != 0) {
        const tree = _.chain(arr)
          .groupBy("station_id")
          .map((o, i) => {
            const name = this.refineryName;
            const colors = REFINERY_COLORS[name] || "OTHER";
            return {
              id: i,
              name,
              colors,
              type: "Refinery",
              value: _.reduce(
                o,
                (sum, a) => {
                  let volumes = _.get(a, "volumes").map((a) => {
                    return Number(a);
                  });
                  return sum + _.sum(volumes);
                },
                0
              ),
              children: _.chain(arr)
                .groupBy("vessel_id")
                .map((a, i) => {
                  const mmsi = _.get(_.find(a, "vessel.mmsi"), "vessel.mmsi");
                  const vm = this; 
                  const mpLogs = this.getTankerbyMMSI(mmsi);
                  let children = [];
                  if (!_.isUndefined(mpLogs)) {
                    const mpData = vm.getTransferLogs(mpLogs.id);
                    children = _.map(mpData, (c) => {
                      return {
                        id: c.tanker_id,
                        name: c.tanker_name,
                        value: c.volume,
                        mmsi: c.mmsi,
                        type: DIRECT_TREE_TYPE.VESSEL,
                        transfer_date: c.transfer_date,
                      };
                    });
                  }
                  return {
                    id: i,
                    name: _.get(_.find(a, "vessel.name"), "vessel.name"),
                    vessel: _.get(_.find(a, "vessel"), "vessel"),
                    type: "Tanker",
                    children,
                    value: _.reduce(
                      a,
                      (sum, value) => {
                        let volumes = _.get(value, "volumes").map((val) => {
                          return Number(val);
                        });
                        return sum + _.sum(volumes);
                      },
                      0
                    ),
                  };
                })
                .value(),
            };
          })
          .value();
        this.init(tree);
      } else this.init(this.defaultData);
    },
  },
};
</script>

<style>
.directTree {
  /* width: 120%; */
  height: 380px;
  font-family: "Prompt", sans-serif;
}
</style>
